import { ThemeConfig } from "antd";

export const dyveTheme: ThemeConfig = {
  token: {
    // colorPrimary: "#e6193d", // red
    colorPrimary: "#24b3a7", // mint
    colorLink: "#003d58",
  },
  components: {
    Button: {
      colorPrimaryBg: "#e6193d",
      colorPrimary: "#e6193d",
      colorPrimaryHover: "#e6193d",
      colorPrimaryActive: "#be0e2d",
    },
    Switch: {
      colorPrimary: "#e6193d",
      colorPrimaryHover: "#f4526e",
    },
  },
};
